import { labelClassificazione } from "_constants";
import { HeaderMainContent, HeaderTableContent } from "components/shared";
import { ButtonAddTopic } from "components/buttons";
import { TopicsTable } from "./components/TopicsTable";
import { InputSearchTopics } from "./components/InputSearchTopics";

export const TopicsPage = () => {
  return (
    <>
      <HeaderMainContent
        child={<ButtonAddTopic />}
        label={labelClassificazione}
      />
      <HeaderTableContent
        child={
          <>
            <InputSearchTopics />
          </>
        }
      />
      <TopicsTable />
    </>
  );
};
